import React, {useRef} from 'react';
import {FC} from 'react';
import styles from './navigation.module.css';
import {MegaMenu} from 'primereact/megamenu';
import {ICommonComponentProps} from '../../definitions/common.definitions';
import {Link, useNavigate} from 'react-router-dom';
import {NAVIGATION_ITEMS} from '../../constants/navigation';
import {usePages} from "../../models/pages/pages-provider";
import {Avatar} from 'primereact/avatar';
import {Menu} from "primereact/menu";
import {useAuth} from "../../providers/auth/auth-provider";
import {RoutesEnum} from "../../constants/routes";
import {MenuItem} from "primereact/menuitem";

export interface INavigationComponentProps
  extends ICommonComponentProps {
}

export const NavigationComponent: FC<INavigationComponentProps> = (props) => {
  const navigate = useNavigate();
  const menuRight = useRef<Menu>(null);
  const {
    data = [],
  } = usePages();
  const {
    user,
    isAuthenticated,
    logout,
    openSignInModal,
  } = useAuth();

  const cabinetHandler = () => {
    isAuthenticated ? navigate(`/${RoutesEnum.CABINET}`) : openSignInModal();
  }

  const avatarMenuItems: MenuItem[] = [
    {
      label: user ? `Добрый день, ${user.name}` : 'Личный кабинет',
      items: [
        {
          // @ts-expect-error
          label: isAuthenticated ? 'Личный кабинет' : 'Войти',
          icon: isAuthenticated ? 'pi pi-user' : 'pi pi-sign-in',
          command: cabinetHandler,
        },
        isAuthenticated ?
        {
          // @ts-expect-error
          label: 'Выйти',
          icon: 'pi pi-sign-out',
          command: logout,
        } : {},
      ]
    }
  ];

  const logoElement = (
    <div
      className={'flex mr-3'}
    >
      <Link
        to={'/'}
      >
        <img
          src={'/images/logo-projection.svg'}
          width={54}
          height={54}
          alt={'Электрические сети Сибири'}
          style={{ marginRight: 16 }}
        />
      </Link>
      <span
        className={styles['logo-text']}
      >
        Электрические<br/>
        Сети Сибири
      </span>
    </div>
  );

  const navigationLogoElement = (
    <div
      className={styles['navigation-logo']}
    >
      {logoElement}
    </div>
  );

  const avatarElement = (
    <Avatar
      icon="pi pi-user"
      size="large"
      style={{ backgroundColor: '#2196F3', color: '#ffffff' }}
      onClick={(event) => menuRight.current?.toggle(event)}
    />
  );

  const endElement = (
    <div
      className={"flex flex-row align-items-center "}
    >
      <div
        className={styles['navigation-end-logo']}
      >
        {avatarElement}
      </div>
    </div>
  );

  const getMenuItemStyle = (context: any) => {
    switch (true) {
      case context.focused:
        return styles['menu-action-focused'];
      case context.active:
        return styles['menu-action-active'];
      default:
        return styles['menu-action'];
    }
  }

  return (
    <div
      className={styles['navigation-wrapper']}
    >
      <MegaMenu
        model={NAVIGATION_ITEMS({ navigate, pages: data })}
        start={navigationLogoElement}
        end={endElement}
        breakpoint={'855px'}
        orientation={'horizontal'}
        pt={{
          root: {
            className: styles['menu-wrapper'],
          },
          menu: {
            className: styles['menu'],
          },
          // @ts-ignore
          action: ({ context }) => ({
            className: getMenuItemStyle(context),
          }),
          // @ts-ignore
          headerAction: ({ context }) => ({
            className: getMenuItemStyle(context),
          }),
          label: {
            className: styles['menu-label'],
          },
          panel: {
            className: styles['menu-panel'],
          },
          submenuHeader: {
            className: styles['menu-submenu-header'],
          },
          submenuIcon: {
            className: styles['menu-action-icon'],
          },
          // @ts-ignore
          menubuttonicon: {
            className: styles['menu-action-popup-icon'],
          }
        }}
      />
      <Menu
        model={avatarMenuItems}
        popup
        ref={menuRight}
        id="popup_menu_right"
        popupAlignment="right"
        pt={{
          root: {
            className: styles.avatarMenuRoot,
          },
          submenuHeader: {
            className: styles.avatarMenuSubheader,
          },
          menuitem: {
            className: styles.avatarMenuitem,
          },
          label: {
            className: styles.avatarMenuitem,
          },
        }}
      />
    </div>
  );
}
